import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    textfield: {
        color: theme.brand.NormalText
    },
}));

export default useStyles;
